import {animate, AnimationBuilder, AnimationPlayer, style} from '@angular/animations';
import {ElementRef, Inject} from '@angular/core';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {isWindowWidthSmaller} from '../../../../core/utils/utils';

export class OffersProgressDialogAnimationBuilder {

    private carAnimationPlayer: AnimationPlayer;
    private carElement: ElementRef;
    private lineAnimationPlayer: AnimationPlayer;
    private lineElement: ElementRef;
    private animationDuration: number;

    private readonly INITIAL_CAR_START_POSITION = '2.36%'; // left property value; car's left offset from road's start
    private readonly CAR_END_POSITION = 'calc(100% - 15.83% - 1.5%)'; // left property value; 15.83% - relative car width, 1.5% - car's right offset from road's end
    private readonly CAR_END_POSITION_MOBILE = 'calc(100% - 25% - 3%)';
    private readonly INITIAL_LINE_START_WIDTH = '19.3%';
    private readonly INITIAL_LINE_START_WIDTH_MOBILE = '31.75%';
    private readonly LINE_END_WIDTH = '100%';
    private readonly ACCELERATION_TIME = 1000;

    constructor(@Inject(AnimationBuilder) private builder: AnimationBuilder) {
    }

    get isMobile(): boolean {
        return isWindowWidthSmaller(698);
    }

    get initialLineStartWidth(): string {
        return this.isMobile ? this.INITIAL_LINE_START_WIDTH_MOBILE : this.INITIAL_LINE_START_WIDTH;
    }

    get carEndPosition(): string {
        return this.isMobile ? this.CAR_END_POSITION_MOBILE : this.CAR_END_POSITION;
    }

    init(carElement: ElementRef, lineElement: ElementRef, animationDuration: number): void {
        this.animationDuration = animationDuration;

        this.carElement = carElement;
        this.buildCarAnimation(this.INITIAL_CAR_START_POSITION, this.animationDuration);

        this.lineElement = lineElement;
        this.buildLineAnimation(this.initialLineStartWidth, this.animationDuration);
    }

    accelerate(): void {
        if (isNotNullOrUndefined(this.carAnimationPlayer)) {
            const carLeftPosition = getComputedStyle(this.carElement.nativeElement).getPropertyValue('left');
            this.buildCarAnimation(carLeftPosition, this.ACCELERATION_TIME);
        }
        if (isNotNullOrUndefined(this.lineAnimationPlayer)) {
            const lineWidth = getComputedStyle(this.lineElement.nativeElement).getPropertyValue('width');
            this.buildLineAnimation(lineWidth, this.ACCELERATION_TIME);
        }
    }

    private buildCarAnimation(carStartPosition: string, animationDuration: number): void {
        if (isNotNullOrUndefined(this.carAnimationPlayer)) {
            this.carAnimationPlayer.destroy();
        }
        const carMovingAnimation = this.builder.build([
            style({
                left: carStartPosition
            }),
            animate(`${animationDuration}ms ease-out`, style({ left: this.carEndPosition }))
        ]);

        this.carAnimationPlayer = carMovingAnimation.create(this.carElement.nativeElement);
        this.carAnimationPlayer.play();

        this.carAnimationPlayer.onDone(() => this.carAnimationPlayer = null);
    }

    private buildLineAnimation(lineStartWidth: string, animationDuration: number): void {
        if (isNotNullOrUndefined(this.lineAnimationPlayer)) {
            this.lineAnimationPlayer.destroy();
        }
        const lineGettingLongerAnimation = this.builder.build([
            style({
                width: lineStartWidth
            }),
            animate(`${animationDuration}ms ease-out`, style({ width: this.LINE_END_WIDTH }))
        ]);

        this.lineAnimationPlayer = lineGettingLongerAnimation.create(this.lineElement.nativeElement);
        this.lineAnimationPlayer.play();

        this.lineAnimationPlayer.onDone(() => this.lineAnimationPlayer = null);
    }
}
